import controller from './summary.controller';
import template from './summary.html';

export default { controller, template };



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/summary/summary.component.js